import { useState, useCallback } from 'react';
import { useClient } from '../../../context/client';
import { useAsyncEffect } from '../../../hooks/useAsyncEffect';

export function usePhotoContest() {
	const client = useClient();
	const [submissions, setSubmissions] = useState([]);
	const [total, setTotal] = useState(0);
	const [counts, setCounts] = useState({});
	const [loading, setLoading] = useState(true);
	const [status, setStatus] = useState('pending');
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(24);

	const fetchSubmissions = useCallback(async () => {
		setLoading(true);
		try {
			const data = await client.getPhotoContestSubmissions({
				status,
				page,
				limit,
			});
			setSubmissions(data.submissions);
			setTotal(data.total);
			setCounts(data.counts || {});
		} catch (e) {
			console.error('Failed to fetch photo contest submissions', e);
		} finally {
			setLoading(false);
		}
	}, [client, status, page, limit]);

	useAsyncEffect(fetchSubmissions, [status, page, limit]);

	const updateStatus = useCallback(
		async (id, newStatus) => {
			try {
				await client.updatePhotoContestStatus(id, newStatus);
				await fetchSubmissions();
			} catch (e) {
				console.error('Failed to update status', e);
			}
		},
		[client, fetchSubmissions],
	);

	return {
		submissions,
		total,
		counts,
		loading,
		status,
		setStatus,
		page,
		setPage,
		limit,
		setLimit,
		updateStatus,
	};
}
